<template>
    <section>
        <div class="row">
            <div class="col-lg-12">
                <PageTitle title="Billings And Subscriptions" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/billings_and_subscriptions',title:'Billings And Subscriptions'}]" />
                <br/>
                <div class="tabs-container" v-if="loggedInRole === 'ROLE_ADMIN'">
                    <ul class="nav nav-tabs nav-justified margin-horizontal-15">
                      <li class="active nav_custom_class text-center"><a data-toggle="tab" href="#restaurantInvoices">All Subscriptions</a></li>
                      <li class="nav_custom_class text-center"><a data-toggle="tab" href="#restaurantSubscriptionAndBilling">Subscription And Billings</a></li>
                    </ul>
                    <div class="tab-content">
                        <div id="restaurantSubscriptionAndBilling" class="tab-pane">
                          <div class="panel-body">
                            <div class="row">
                              <div class="col-md-12">
                                <RestaurantSubscriptionAndBilling></RestaurantSubscriptionAndBilling>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div id="restaurantInvoices" class="tab-pane active">
                        <div class="panel-body">
                          <div class="row">
                            <div class="col-md-12">
                              <RestaurantsInvoices @updateSelectedRestaurant="updateSelectedRestaurant"></RestaurantsInvoices>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
              </div>
                <div v-else>
                  <div class="col-md-12">
                    <RestaurantSubscriptionAndBilling></RestaurantSubscriptionAndBilling>
                  </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import RestaurantsInvoices from '@/components/billings/AllRestaurantsInvoices'
    import RestaurantSubscriptionAndBilling from '@/components/billings/RestaurantSubscriptionAndBilling'
    import PageTitle from '@/components/layout_components/PageTitle'
    export default {
        name: "RestaurantBilings",
        data () {
            return {
                loggedInRole:'fkjhfj',
                dateRange: "",
                getElementByClass: false,
                start_date: "",
                allRestaurants:[],
                selectedRestaurant:null,
                branches:[],
                isHideSpinner: "hide",
                isSubscriptionExist:false,
                billingStats:{
                    "total_orders":0,
                    "cancelled_order":0,
                    "commission":0.0
                },
                billingPeriod:{
                    "start":"",
                    "end":""
                },
                currentSubscription:'',
                subscriptionObj:{
                    "subscriptionName": "DVM Standard Subscription",
                    "restaurantId": {
                        "id":0
                    }
                }
            }
        },
        components: {
            RestaurantsInvoices,
            RestaurantSubscriptionAndBilling,
            PageTitle
        },
      mounted() {
        this.loggedInRole = this.$store.state.user.userRolesById[0].role;
      },
      methods:{
            updateSelectedRestaurant: async function (restaurantId) {
              let params = new URLSearchParams();
              params.append("restaurant_id", restaurantId);
              await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_by_id", params).then( async resp => {
                this.selectedRestaurant = resp.data;
                // await this.$parent.fetchBranchesOfRestaurant();
                console.log(resp.data);
              });

            },
            getClass: function(status){
                switch(status){
                    case 'paid':
                      return 'label-success';
                      break;
                    case 'pending':
                      return 'label-danger';
                      break;
                }
              }
        }
    }
</script>

<style scoped>
.nav_custom_class{
  width: 50% !important;
}
</style>